module.exports = __webpack_public_path__ + "static/img/exam-2-bg.218f025.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/exam-2-bg.png
// module id = i6iB
// module chunks = 1